import { render, staticRenderFns } from "./TeachersTable.vue?vue&type=template&id=49602948&scoped=true&"
import script from "./TeachersTable.vue?vue&type=script&lang=ts&"
export * from "./TeachersTable.vue?vue&type=script&lang=ts&"
import style0 from "./TeachersTable.vue?vue&type=style&index=0&id=49602948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49602948",
  null
  
)

export default component.exports